(ns motorsaif.web.components.chat
  (:require
   ["react" :as react]
   ["react-transition-group" :refer [CSSTransition TransitionGroup]]
   [motorsaif.constants :as constants]
   [clojure.string :as str]
   [goog.dom.Range :as grange]
   [goog.functions :refer [debounce]]
   [motorsaif.frontend-routes :as routes]
   [motorsaif.i18n :as i18n :refer [tr]]
   [motorsaif.shared.chat :as shared-chat]
   [motorsaif.time :as time]
   [motorsaif.url :as url]
   [motorsaif.utils :as utils :refer [locals->map]]
   [motorsaif.web.components :as c]
   [motorsaif.web.lib.form :as form]
   [motorsaif.web.photos :as photos]
   [motorsaif.web.utils :as web-utils]
   [re-frame.core :as rf :refer [subscribe]]
   [reagent.core :as r]
   [reagent.ratom :as ra]
   [taoensso.encore :as encore]))

(defn- scroll-chat-bottom [el]
  (set! (.-scrollTop el) (.-scrollHeight el)))

(def ^:private debounced-scroll-bottom (debounce scroll-chat-bottom 30))


(defn- div-editable [{:keys [from-id thread-id participant set-val submit-form]} ^js ref *touch-lock]
  (fn []
    (let [placeholder (tr :page.chat.type-placeholder)
          focus-fn
          (fn [e]
            (.add (.-classList js/document.documentElement) "kb-open")
            (js/setTimeout (fn []
                             (let [curr (.-current ref)
                                   elrange (grange/createFromNodeContents curr)
                                   c (.-textContent curr)]

                               ;; (reset! *height (.-innerHeight js/window))
                               ;; (rf/dispatch [:update-data :vsm
                               ;;               (fn [m]
                               ;;                 (assoc m :inner-height (.-innerHeight js/window)))])

                               (when (= c placeholder)
                                 (set! (.-textContent curr) ""))
                               (.focus curr)
                               (.collapse elrange false)
                               (.select elrange))) 5))]
      (r/create-class
        {:component-did-mount #(set! (.-textContent (.-current ref)) placeholder)
         :reagent-render
         (fn []
           [:div.div-editable
            (-> {:ref ref
                 :contentEditable true
                 :spell-check true
                 :role "textbox"
                 :on-touch-end (fn [e]
                                 (let [focused? (= (.-current ref) js/document.activeElement)]
                                   (when-not focused?
                                     (.focus (.-current ref)))))
                 :on-focus focus-fn
                 :on-blur (fn [e]
                            (if @*touch-lock
                              (do
                                (.preventDefault e)
                                (.focus (.-current ref)))
                              (do
                                (.remove (.-classList js/document.documentElement) "kb-open")
                                (let [curr (.-current ref)
                                      txt (.-textContent curr)]
                                  (when (empty? txt)
                                    (set! (.-textContent curr) placeholder))))))

                 :on-input
                 (fn [^js e]
                   (rf/dispatch [:sente-send-limited
                                 :message/typing
                                 {:from-id from-id
                                  :to-id (:db/id participant)
                                  :thread-id thread-id}])

                   (set-val
                    [:message :message/body]
                    (str/trim (.-currentTarget.innerText e))
                    #_(.-currentTarget.textContent e)))}
                (assoc :on-key-press #(let [keycode (.-charCode %)
                                            enter? (= keycode 13)
                                            shift? (.-shiftKey %)]
                                        (when (and utils/is-desktop?
                                                   (not (and shift? enter?))
                                                   enter?)
                                          (submit-form %)))))])}))))


(defn- upload-images [{:keys [form *dirty]}]
  (let [media-path [:message :message/media]
        {:keys [input
                form-params
                get-val
                *data
                uploader uploaded-media]} form
        *expanded (r/atom false)
        id (gensym "upload")
        outside-click
        #(utils/on-click-outside-element
          {:element-id id
           :on-outside-click (fn []
                               (reset! *expanded false))})]
    (outside-click)
    (fn []
      [:div
       {:id id}
       (when @*expanded
         [:div#expanded-image-uploader
          [:h4  (tr :page.chat.media.upload-media)]
          [:span.text.small (tr :page.chat.media.max-4)]
          [uploaded-media media-path]
          [uploader media-path
           {:file-limit 4
            :on-success (fn []
                          (reset! *expanded false))
            :choose-comp
            (fn [params]
              [:button.btn.choose-imgs.primary
               params
               (tr :page.chat.media.choose-images)])}]
          (when (seq (get-val media-path))
            [:button.btn.secondary.submit
             {:type "submit"
              :on-click #(reset! *expanded false)}
             (tr :page.chat.media.send)])])
       [:button.btn.uploader.ghost
        {:type "button"
         :on-click #(do
                      (outside-click)
                      (reset! *expanded true))}
        [:i.fas.fa-paperclip]]])))

(defn- message-form [{:keys [thread-id
                             current-owner-id
                             current-user-id
                             request-id
                             from-id
                             participant] :as args}]

  (encore/have some? current-owner-id request-id from-id)
  (let [input-ref ^js (react/createRef)
        *touch-lock (r/atom false)
        clear-input-fn #(set! (.-current.textContent input-ref) "")
        form-params (shared-chat/chat-form-params
                     (locals->map
                      thread-id
                      current-user-id
                      current-owner-id
                      clear-input-fn
                      from-id))
        {:keys [form-params get-val] :as form} (form/make-form form-params)]
    (rf/dispatch [:assoc-data [:forms :message-form] {:form form
                                                      :input-ref input-ref}])
    ;; (get-in @re-frame.db/app-db [:forms])
    (fn []
      [:form.message-form
       form-params
       #_[:div.debug
          ;; (get-in @re-frame.db/app-db zhe)
          (str (dissoc @*data :on-submit))]
       [:div.input-with-inline-actions
        [:div#uploader-wrap
         [upload-images {:form form}]]
        [div-editable (assoc form
                             :from-id current-owner-id
                             :thread-id thread-id
                             :participant participant) input-ref *touch-lock]
        [:div.right-buttons
         (if (get-val [:message :db/id])
           [:<>
            [:button.btn.send-msg.no-bg
             {:type "button"
              :on-click #(rf/dispatch [:message/edit-cancel])}
             [:i.fas.fa-cancel]]
            [:button.btn.send-msg.no-bg
             {:type "submit"
              :on-touch-end (fn []
                              (reset! *touch-lock true)
                              (js/setTimeout
                               (fn []
                                 (reset! *touch-lock false))
                               100))}
             [:i.fas.fa-check]]]
           [:button.btn.send-msg.no-bg
            {:type "submit"
             :on-touch-end (fn []
                             (reset! *touch-lock true)
                             (js/setTimeout
                              (fn []
                                (reset! *touch-lock false))
                              100))}
            [:i.fas.fa-paper-plane]])]]])))

;; (defn- last-sent-time [last-seen]
;;   (let [*dirty (r/atom 0)
;;         *interval (atom nil)]
;;     (r/create-class
;;       {:component-did-mount #(reset! *interval (js/setInterval
;;                                                 (fn []
;;                                                   (swap! *dirty inc)) 1000))
;;        :component-will-unmount #(js/clearInterval @*interval)
;;        :reagent-render
;;        (fn []
;;          ^{:key @*dirty}
;;          [:span.last-seen
;;           [:last-seen
;;            (tr :page.chat.last-seen)
;;            (time/tr-ago-str last-seen)]])})))

(defn- last-seen-comp [last-seen]
  (let [*dirty (r/atom 0)
        *interval (atom nil)]
    (r/create-class
      {:component-did-mount #(reset! *interval (js/setInterval
                                                (fn []
                                                  (swap! *dirty inc)) 1000))
       :component-will-unmount #(js/clearInterval @*interval)
       :reagent-render
       (fn []
         ^{:key @*dirty}
         [:span.last-seen
          [:last-seen
           (tr :page.chat.last-seen)
           (time/tr-ago-str last-seen)]])})))

;; just make a sub for latest so don't doall this crap
(defn service-provider-interaction-expanded [{:keys [*expanded]}]
  (let [*selected (r/atom nil)]
    (fn [{:keys [status-data *status status-options thread-id] :as args}]
      (let [{current-label :label
             next-options :next-options
             current-description :description} status-data
            shown-options (filter #((or next-options #{}) (:id %)) status-options)
            shown-options (if (seq shown-options)
                            shown-options
                            (take 10 status-options))]
        [:div.service-provider-expanded
         [:div.header "Update Status"]
         (into
          [:div.options]
          (map (fn [{:keys [label description] :as itm}]
                 [:div.option
                  {:class (when (= label
                                   (or
                                    (:label @*selected)
                                    current-label)) "selected")
                   :on-click #(reset! *selected itm)}
                  [:div.label label]]) shown-options))
         (when-let [description (or
                                 (:description @*selected)
                                 current-description)]
           [:div.selected-desc
            [:span.title "Explanation"]
            [:span.desc description]])
         [:button.btn.primary.full
          {:on-click #(do
                        (reset! *expanded false)
                        (rf/dispatch [:set-interaction-status
                                     thread-id
                                     (:label @*selected)]))}
          "Update"]]))))

(defn request-owner-interaction-expanded [{:keys [status-data] :as args}]
  (let [{:keys [description]} status-data]
    [:div.request-owner-expanded
     ;; [:div.header "Help"]
     ;; [:p.desc "This indicates what step the business you're speaking with is currently on with your request."]
     [:div.header "Explanation"]
     [:p.desc description]]))

(defn interaction-status-comp [{:keys [request thread-id current-owner-id] :as args}]
  (rf/dispatch [:get-interaction-status thread-id])
  (let [*status (rf/subscribe [:current-interaction-status thread-id])
        *expanded (r/atom false)
        request-type (get-in request [:request/type :db/ident])
        request-owner-id (get-in request [:owner :db/id])
        request-owner? (= current-owner-id request-owner-id)
        status-options (get constants/interaction-status request-type)
        args (assoc args
                    :*expanded *expanded
                    :status-options status-options
                    :*status *status)]
    (fn []
      (let [selected-status (or (:label @*status)
                                "Introduction")
            {:keys [label badge-class indicator] :as status-data}
            (first (filter #(= (:label %) selected-status) status-options))
            args (assoc args :status-data status-data)
            ]
        [:div#interaction-status
         [:div.shown
          [:span.title "Interaction Status"]
          [:span.badge
           {:class (or badge-class "default")}
           ;; Indicator is shown when the user should wait for us
           (when indicator
             [:span.indicator])
           [:span.status-text
            {:on-click #(swap! *expanded not)}
            label
            (if @*expanded
              [:i.fas.fa-caret-up]
              [:i.fas.fa-caret-down])
            ]]
          #_[:span.time "5 mins ago"]]
         (when @*expanded
           (if request-owner?
             [request-owner-interaction-expanded args]
             [service-provider-interaction-expanded args])
           )]))))

(defn- floaty [{:keys [request thread-id] :as args}]
  (let [*expanded? (r/atom false)]
    (fn [{:keys [participant]}]
      (let [{:request/keys [media object description category]
             owner :owner} request
            thumb-src (url/uploaded-media {:media (first media)
                                           :size :med})
            {:car/keys [make model year]} object
            handle (utils/owner-handle participant)
            {participant-id :db/id} participant
            typing? @(rf/subscribe [:typing-status thread-id participant-id])
            online-state @(subscribe [:user-online-state participant-id])
            last-seen @(subscribe [:user-last-seen participant-id])
            business? (some? (:business/name participant))
            ]

        ;; Update last seen if a user comes online
        @(ra/reaction
          @(subscribe [:user-online-state participant-id])
          (rf/dispatch [:last-seen participant-id]))

        [:div.participant
         {:class (when @*expanded? "expanded")}
         [:div.wrap
          [:div.preview
           [:div.grid
            {:on-click #(swap! *expanded? not)}
            [c/avatar-letter participant {:class "med"}]
            [:div.info
             [:div.handle
              (when business?
                [c/verified-badge participant])
              handle
              (cond
                typing?
                [:span.typing " " (tr :page.chat.is-typing)
                 [:span.dots
                  [:span.dot]
                  [:span.dot]
                  [:span.dot]]])]
             (cond online-state
                   (condp = online-state
                     :online [:span.last-seen "Online"]
                     :busy [:span.last-seen "Busy"]
                     :idle [:span.last-seen "Idle"])
                   (and last-seen (not online-state))
                   [:span.last-seen
                    [:last-seen
                     (tr :page.chat.last-seen)
                     [c/ago-str-interval last-seen 1000]]])]

            [:div.right
             #_(when thumb-src
                 [:img.thumb {:src thumb-src}])
             [:div.view-req  (tr :page.messages.profile)
              (if @*expanded?
                [:i.fas.fa-caret-up]
                [:i.fas.fa-caret-down])]]]
           [interaction-status-comp args]]

          (when @*expanded?
            [:div.expanded
             #_(when thumb-src
                 [:img.thumb {:src thumb-src}])
             #_[:section [:h3 "Business"]
                [:div.type "Repair Garage"]
                [:div.type "Visit Profile"]]
             (if business?
               [:section.view-biz
                [:p
                 (:business/description participant)]
                [:a.btn.primary.fw
                 {:href (routes/path-for :public-profile {:id participant-id})} "Visit Business Page"]]
               [:section
                "Private User"])])]]))))

(defn- chat-media [{:keys [media]}]
  (into [:div.photo-grid
         {:class (str "n-" (count media))}]
        (map-indexed (fn [idx itm]
                       (let [{media-id :db/id} itm
                             src (url/uploaded-media {:media itm
                                                      :size :med})]
                         ^{:key media-id}
                         [:div.media-item
                          {:on-click #(photos/photoswipe idx media)}
                          [:img {:src src}]]))) media))

;; (concat zhe @*msgs)
;; @*msgs

;; (def id1 (random-uuid))
;; (def msg1 {
;;            :date-time/created #inst "2024-06-28T15:45:48.015-00:00",
;;            :uuid id1
;;            :message/body "satfat",
;;            :message/from {:db/id 17592186051752, :user/handle "tomar"}})

;; (def msg1-ack {:db/id 17592186051923,
;;                :date-time/created #inst "2024-06-28T15:45:48.015-00:00",
;;                :uuid id1
;;                :message/body "satfat",
;;                :message/from {:db/id 17592186051752, :user/handle "tomar"}})

;; (def id2 (random-uuid))
;; (def msg2 {:db/id 17592186051923,
;;            :uuid id2
;;            :date-time/created #inst "2024-06-28T15:45:48.015-00:00",
;;            :message/body "fat",
;;            :message/from {:db/id 17592186051752, :user/handle "tomar"}})

;; (rf/dispatch [:update-data [:requester-threads [17592186051827 17592186045449] :thread] conj msg1-ack])
;; (:requester-threads @re-frame.db/app-db)
;; (get-in @re-frame.db/app-db [:requester-threads [17592186051827 17592186045449] :thread])


;; (swap! *msgs assoc id1 msg1)
;; (swap! *msgs assoc id1 msg1-ack)
;; (swap! *msgs conj msg1-ack)
;; (swap! *msgs assoc id2 msg2)

;; (thread* zhe)

;; (comment (concat zhe (vals @*msgs)))
;; (thread* zhe)

;; ((conj #{:one} :two) :one)
;; (concat msgs (vals @*msgs))


(defn message-controls [data]
  (let [{:keys [seen? ack? is-owner? has-next? new-author? author is-user?]
         created :date-time/created
         id :db/id
         :message/keys [body from media]} data
        date (time/date->format created "h:mm A")
        {:keys [from audit]} author
        *copied (r/atom false)
        copy-cb (fn [] (js/setTimeout
                        #(reset! *copied false) 1500))]
    (fn []
      [:div.message-controls
       (when body
         [:button.copy
          {:type "button"
           :on-click #(do
                        (reset! *copied true)
                        (web-utils/copy-fn body copy-cb))}
          (if @*copied
            [:i.fal.fa-check]
            [:i.fal.fa-copy])])
       (when is-user?
         [:<>
          [c/confirm-action
           [:i.fal.fa-trash]
           #(rf/dispatch [:message/delete id])
           1500]
          (when body
            [:button.edit
             {:type "button"
              :on-click #(rf/dispatch [:message/edit id body])}
             [:i.fal.fa-edit]])])])))

(defn message [data]
  (let [{:keys [seen? ack? is-owner? has-next? new-author? author is-user?]
         :date-time/keys [created updated]
         id :db/id
         :message/keys [body from media]} data
        created-date (time/date->format created "h:mm A")
        updated-date (when updated (time/date->format updated "MMM dd h:mm A"))
        {:keys [from audit]} author
        control-show-fn #(when id
                           (rf/dispatch [:set-ui-state [:message-controls] id]))


        handle (cond (and is-owner?
                          audit)
                     (utils/owner-handle from)
                     is-owner?
                     "You"
                     :else
                     (utils/owner-handle from))
        audit-handle (when audit
                       (cond
                         is-user?
                         "You"
                         is-owner?
                         (utils/owner-handle audit)))
        ]
    [:div.chat-msg-outer
     {:class (str (if is-owner? "me" "them")
                  (when has-next? " has-next"))
      :tab-index 0
      :on-blur #(rf/dispatch [:set-ui-state [:message-controls] nil])
      :on-focus control-show-fn}
     [:div.wrap
      (when new-author?
        [:div.handle handle]
        #_(cond (and is-owner?
                     audit)
                [:div.handle (utils/owner-handle from)]
                is-owner?
                [:div.handle "You"]
                :else
                [:div.handle (utils/owner-handle from)]))
      (when audit
        [:div.audit-handle audit-handle]
        #_(cond
            is-user?
            [:div.audit-handle "You"]
            is-owner?
            [:div.audit-handle (utils/owner-handle audit)]))

      [:span.body body]
      (when (seq media)
        [chat-media {:media media}])
      [:div.ts-wrap
       [:span.timestamp created-date]
       (when updated
         [:div.updated
          [:span "Edited: "]
          [:span.timestamp updated-date]])
       (when is-owner?
         [:span.tick-status
          (cond
            (and ack? seen?)
            [:span.read-receipt
             [:i.fa-regular.fa-check]
             [:i.fa-regular.fa-check]]
            ack?
            [:span.message-ack
             [:i.fa-regular.fa-check]])])]]
     (when (= id @(rf/subscribe [:ui-state :message-controls]))
       [message-controls data])]))

;; TODO FIX, we changed thread*
(defn messages [{:keys [*ul-ref
                        current-owner-id
                        current-user-id
                        request-id
                        form
                        participant
                        client-msgs
                        from-id
                        thread]}]

  (r/create-class
    {:component-did-mount #(debounced-scroll-bottom @*ul-ref)
     :component-did-update #(debounced-scroll-bottom @*ul-ref)
     :reagent-render
     (fn [{:keys [thread]}]
       [:ul.scroll.chat-msgs
        {:ref #(do
                 (reset! *ul-ref %))}
        (into [:> TransitionGroup
               {:class-name "tg-wrap"
                :mode "in-out"}]
              (map
               (fn [{:keys [type] :as msg}]
                 [:> CSSTransition
                  {:timeout 500
                   :class-names "msg-anim-wrap"}
                  (condp = type
                    :date [:div.chat-msg-outer.date
                           [:div.val
                            (:date msg)]]
                    :msg
                    [message (assoc msg :form form)])])
               (shared-chat/thread*
                {:thread thread
                 :*client-msgs client-msgs
                 :current-user-id current-user-id
                 :current-owner-id current-owner-id})))])}))

;; TODO
;; refactor this so this is actually a root component and builds itself from
;; route params
(defn main-chat [{:keys [current-owner-id
                         *thread
                         client-msgs
                         from-id
                         request
                         thread-id
                         path] :as args}]
  ;; (assert (and current-owner-id *thread from-id request))
  (let [*ul-ref (atom nil)
        request-id (:db/id request)
        current-user-id (:db/id @(subscribe [:user]))
        thread @*thread
        request-status (get-in request [:request/status :db/ident])
        participant (shared-chat/other-participant {:thread thread
                                                    :request request
                                                    :current-owner-id current-owner-id})]

    [:div.chat-thread
     ;; {:style {:height @*inner-height}}
     [floaty {:request request
              :current-owner-id current-owner-id
              :participant participant
              :thread-id thread-id
              :thread thread}]
     [messages {:*ul-ref *ul-ref
                :current-owner-id current-owner-id
                :current-user-id current-user-id
                :request-id request-id
                :participant participant
                :client-msgs client-msgs
                :thread thread
                :from-id from-id}]
     (when (= request-status :active)
       [message-form {
                     ;; :*ul-ref *ul-ref
                     ;; :form form
                     :path path
                     :thread-id thread-id
                     :from-id from-id
                     :participant participant
                     :thread thread
                     :current-user-id current-user-id
                     :current-owner-id current-owner-id
                     :request-id request-id}])]))
